import { render, staticRenderFns } from "./index.vue?vue&type=template&id=043eaa29"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('043eaa29')) {
      api.createRecord('043eaa29', component.options)
    } else {
      api.reload('043eaa29', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=043eaa29", function () {
      api.rerender('043eaa29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/index.vue"
export default component.exports